import { useEffect } from 'react';
import { useXero } from '../contexts/XeroContext';

export function XeroCallback() {
  const { handleCallback } = useXero();

  useEffect(() => {
    console.log(' XeroCallback component mounted');
    console.log(' Current URL:', window.location.href);
    console.log(' URL parts:', {
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash
    });

    const getCodeFromUrl = () => {
      console.log(' Attempting to extract code from URL');
      
      // Try to get code from URL parameters
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      console.log(' Code from URLSearchParams:', code);
      
      if (!code) {
        console.log(' No code found in search params, trying full URL parsing');
        try {
          const fullUrl = window.location.href;
          const url = new URL(fullUrl);
          const urlCode = url.searchParams.get('code');
          console.log(' Code from URL parsing:', urlCode);
          return urlCode;
        } catch (error) {
          console.error(' Error parsing URL:', error);
          return null;
        }
      }
      
      return code;
    };

    const code = getCodeFromUrl();
    
    if (code) {
      console.log(' Found authorization code, length:', code.length);
      console.log(' Initiating callback handling');
      
      handleCallback(code)
        .then(() => {
          console.log(' Xero authentication successful');
          console.log(' Attempting to message opener window');
          
          if (window.opener) {
            console.log(' Opener window found, sending success message');
            window.opener.postMessage({ 
              type: 'XERO_AUTH_SUCCESS',
              timestamp: new Date().toISOString()
            }, '*');
            console.log(' Closing popup window');
            window.close();
          } else {
            console.warn(' No opener window found');
          }
        })
        .catch((error) => {
          console.error(' Xero authentication error:', error);
          console.error(' Error details:', {
            message: error.message,
            stack: error.stack,
            name: error.name
          });
          
          if (window.opener) {
            console.log(' Sending error to opener window');
            window.opener.postMessage({ 
              type: 'XERO_AUTH_ERROR', 
              error: error.message,
              timestamp: new Date().toISOString(),
              details: {
                errorType: error.name,
                errorStack: error.stack
              }
            }, '*');
            console.log(' Closing popup window after error');
            window.close();
          } else {
            console.warn(' No opener window found to send error');
          }
        });
    } else {
      console.error(' No authorization code found in URL');
      console.log(' URL details:', {
        fullUrl: window.location.href,
        params: Object.fromEntries(new URLSearchParams(window.location.search).entries())
      });
      
      if (window.opener) {
        console.log(' Sending missing code error to opener');
        window.opener.postMessage({ 
          type: 'XERO_AUTH_ERROR', 
          error: 'No authorization code found',
          timestamp: new Date().toISOString(),
          urlDetails: {
            pathname: window.location.pathname,
            search: window.location.search
          }
        }, '*');
        console.log(' Closing popup window');
        window.close();
      }
    }
  }, [handleCallback]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="text-center text-white">
        <h1 className="text-xl font-semibold mb-4">Processing Xero Authentication...</h1>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
        <div className="mt-4 text-sm text-gray-400">
          URL: {window.location.href}
        </div>
      </div>
    </div>
  );
}
